/* eslint-disable @typescript-eslint/camelcase */
import React from 'react';
import { Grid, makeStyles, createStyles } from '@material-ui/core';
import { graphql, useStaticQuery } from 'gatsby';
import { TrainerCard } from './trainer-card';
import { nameRepresentation } from '../../utils/text-formatting';

const HIDE_PRICE = true

type Trainer = {
  _id: string;
  first_name: string;
  last_name: string;
  plan_id: string;
  bio: string;
  cover_image_url: string;
  profile_pic_url: string;
  available_spots: number;
};
const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    item: {
      marginTop: spacing(3),
    },
  })
);

export const TrainersList = () => {
  const data = useStaticQuery<{ allTrainer: { nodes: Array<Trainer> } }>(
    graphql`
      query {
        allTrainer(sort: {fields: available_spots, order: DESC}) {
          nodes {
            first_name
            last_name
            cover_image_url
            profile_pic_url
            available_spots
            bio
            _id
          }
        }
      }
    `
  );

  const trainers = data.allTrainer.nodes;
  const classes = useStyles();

  return (
    <Grid container direction="row">
      {trainers &&
        trainers.map((data: Trainer) => {
          const name = nameRepresentation(data.first_name, data.last_name);
          return (
            <Grid item sm={4} className={classes.item} key={data._id}>
              <TrainerCard
                name={name}
                availableSpots={data.available_spots}
                bio={data.bio}
                price={200}
                coverImage={data.cover_image_url}
                profilePicture={data.profile_pic_url}
                link={`/trainers/${data._id}`}
                hidePrice={HIDE_PRICE}
              />
            </Grid>
          );
        })}
    </Grid>
  );
};
